<template>
    <div :class="$style['stores-css']">
        <div style="width: 100%;">
            <div style="display: flex; justify-content: space-between;
                 background-color: #dbdada; height: 45px" v-if="!search_open">
                <span style="width: 100%; display: flex; justify-content: space-between;
                             background-color: #dbdada; height: 45px;align-items: center; margin-right: 15px">فروشگاه ها</span>
            </div>

            <div style="display: flex; justify-content: space-between;
                height: 40px" v-if="search_open">
                <v-text-field
                        hide-details="false"
                        solo
                        @keyup="handleChangeInput"
                        v-model="searchInput"
                        placeholder="جستجوی محصولات ...">
                </v-text-field>
                <v-icon style="z-index: 20; color: black;position: absolute; left: 10px; top: 10px;"
                        role="button" v-ripple @click="ClickClose">close
                </v-icon>
            </div>
        </div>
        <v-tabs
                v-model="tabs"
                fixed-tabs color="gray" style="font-size: 11px; position: sticky; top: 1;">
            <v-tab
                    style="font-size: 11px"
                    v-for="n in items"
                    :key="n">
                {{ n }}
            </v-tab>
        </v-tabs>
        <div id="mapOrder" :class="[$style['MainMapCss'], $style['scrollTop']]" v-if="IsLoadMap">
            <mapir :apiKey="MapirApiKey" :center="center" v-if="IsLoadMap" :class="$style['MainMapCss_Sub']">
                <mapAttributionControl/>
                <mapNavigationControl position="top-right"/>
                <mapGeolocateControl position="top-left"/>
                <mapScaleControl position="top-left"/>
                <mapMarker @click="markerOnClick(item)"
                        v-for="(item, index) in currentArray"
                        :coordinates="item.lng"
                        :key="index"
                        :draggable="false">
                    <img :src="item.marker" alt="" slot="marker" :class="$style['mapMarker']"
                         style="width: 9%"/>
                </mapMarker>
            </mapir>
        </div>
        <v-dialog v-model="modalLogin" transition="scroll-y-transition">
            <v-card role="button" v-ripple @click="OpenStore" :class="[$style['box-modal'], $style['stores-css']]">
                <div :class="$style['headline-tv']">
                    <h3>{{dataStore.shop_name}}</h3>
                    <div :class="$style['backpages']" role="button" v-ripple @click="modalLogin = false, this.isCode = false">
                    </div>
                </div>
                <div style="display: flex;justify-content: space-between; font-size: 12px; align-items: center; margin-bottom: 15px">
                    <p style="margin-right: 15px; font-size: 14px; margin-bottom: 0; margin-left: 10px">
                        {{dataStore.shop_address}}</p>
                    <v-btn style="margin-left: 15px; border-radius: 20px; background-color: #7ec352;
                     color: white; font-size: 12px" role="button" v-ripple @click="Route()">
                        <v-icon style="font-size: 14px">explore</v-icon>
                        مسیریابی
                    </v-btn>
                </div>
                <div style="display: flex; font-size: 12px; margin-bottom: 20px; margin-right: 15px">
                    <v-btn v-if="dataStore.shop_type == 0" style="font-size: 12px; border-radius: 20px;
                     background-color: white; color: #7ec352; margin-left: 10px">
                        <v-icon style="font-size: 12px">scatter_plot</v-icon>
                        خرید اینترنتی
                    </v-btn>
                    <v-btn v-if="dataStore.shop_type == 1" style="font-size: 12px; border-radius: 20px;
                     background-color: white; color: #ff0000; margin-left: 10px">
                        <v-icon style="font-size: 12px">scatter_plot</v-icon>
                        خرید حضوری
                    </v-btn>
                    <v-btn v-if="dataStore.shop_delivery == true" style=" font-size: 12px; border-radius: 20px;
                     background-color: #2ab0f7; color: white">
                        <v-icon style="font-size: 12px">check</v-icon>
                        ارسال با پیک
                    </v-btn>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
    import oracle from "@/utils/oracle";
    import {
        mapir,
        mapMarker,
        mapAttributionControl,
        mapNavigationControl,
        mapGeolocateControl,
        mapScaleControl,
    } from "mapir-vue";

    export default {
        name: "Stores",
        components: {
            mapir,
            mapNavigationControl,
            mapMarker,
            mapAttributionControl,
            mapGeolocateControl,
            mapScaleControl,
        },
        data() {
            return {
                MapirApiKey: "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6Ijc3OTZjOTI0MGJlNzA2ODFhZjkwOGZmNjJkMmNmZDZjZGEyZGZiYjg5ZTk1YzYwYmI5ODFkZDA1ZGM4YWUzMDdlZmE1YmEwMGEwMDUyNTcxIn0.eyJhdWQiOiIxMjg0MyIsImp0aSI6Ijc3OTZjOTI0MGJlNzA2ODFhZjkwOGZmNjJkMmNmZDZjZGEyZGZiYjg5ZTk1YzYwYmI5ODFkZDA1ZGM4YWUzMDdlZmE1YmEwMGEwMDUyNTcxIiwiaWF0IjoxNjEzNTYxNDIwLCJuYmYiOjE2MTM1NjE0MjAsImV4cCI6MTYxNjA2NzAyMCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.PGE1y2V5xX6kKL5qG08k21qZ5fzge8RD_DaBkMuQW7vOdHFzwnM1rGnuiCQ9dPw7irbURXkNT5SdLRWGAjDzahK4dH6Y4QT3DScuEm05ZSozzgWaBMNDdQmBF8-Hi01StkZqBP4wrZMLO1PpxgEe9zjbZRSY_yfFr4usUuSyYeYxT3DPo4GrDz7WFWzpl73mKl30ka_THDdPj0d3f_cnwAOsZuETS3hzeb_duplYGIbwJAFZ4OsTlVKYnxPp8lHyboa3rwP0I3inQB2o-lzZFJjsEGZYhVKZeayUR_3t4DthI52NJvJDvTYb-yAs5zXcm6vWDnWEc0Kd9pp45qPcAQ",
                center: [51.420296, 35.732379],
                story: false,
                IsLoadMap: false,
                modalLogin: false,
                Array_all: [],
                Array_deliver: [],
                Array_online: [],
                currentArray: [],
                search_open: false,
                handleChangeInput: '',
                searchInput: '',
                items: ['همه فروشگاه ها', 'سفارش دلیوری', 'سفارش آنلاین'],
                tabs: null,
                dataStore: '',
                map_element: '',
            };
        },
        methods: {
            OpenStore() {
                this.$router.push({"name": 'StoreInfo', "query": {"id": this.dataStore.shop_id}})
            },
            ClickClose() {
                this.search_open = false
            },
            markerOnClick(e) {
                this.map_element = e
                this.title = e.title
                for (let i = 0; i < this.AllMapData.length; i++) {
                    if (this.title == this.AllMapData[i].shop_name) {
                        this.dataStore = this.AllMapData[i]
                    }
                }
                this.modalLogin = true
            },
            Route() {
                let link = "https://www.google.com/maps/@" + this.map_element.lng[1] + "," + this.map_element.lng[0] + ",19z"
                window.open(link, '_blank');
            },
            getlatLng(params) {
                this.lat = params.marker._lngLat.lat;
                this.lng = params.marker._lngLat.lng;
            },
            GetCatMap(response) {
                this.AllMapData = response.data;
                let Array = [];
                let Array_deliver = []
                let Array_online = []
                for (let i = 0; i < this.AllMapData.length; i++) {
                    Array.push({
                        id: i,
                        title: this.AllMapData[i].shop_name,
                        lng: [this.AllMapData[i].shop_longitude, this.AllMapData[i].shop_latitude],
                        marker: this.AllMapData[i].shop_icon,
                    })
                    if (this.AllMapData[i].shop_delivery == true) {
                        Array_deliver.push({
                            id: i,
                            title: this.AllMapData[i].shop_name,
                            lng: [this.AllMapData[i].shop_longitude, this.AllMapData[i].shop_latitude],
                            marker: this.AllMapData[i].shop_icon,
                        })
                    }
                    if (this.AllMapData[i].shop_type == 0) {
                        Array_online.push({
                            id: i,
                            title: this.AllMapData[i].shop_name,
                            lng: [this.AllMapData[i].shop_longitude, this.AllMapData[i].shop_latitude],
                            marker: this.AllMapData[i].shop_icon,
                        })
                    }
                }
                this.Array_all = Array;
                this.Array_deliver = Array_deliver
                this.Array_online = Array_online
                this.currentArray = Array
                this.IsLoadMap = true;
            }
        },
        mounted() {
            oracle.axios(
                "shop/getList",
                {"limit_by": 500},
                this.GetCatMap
            );
        }, watch: {
            tabs: function (val) {
                switch (val) {
                    case 0:
                        this.currentArray = this.Array_all
                        break
                    case 1:
                        this.currentArray = this.Array_deliver
                        break
                    case 2:
                        this.currentArray = this.Array_online
                        break
                }
            }
        }
    };
</script>
<style module>

    .headline-tv {
        margin-top: 15px;
        margin-bottom: 15px;
        padding-left: 15px;
        padding-right: 15px;
        display: flex;
        justify-content: space-between;
    }

    .stores-css {
        display: flex;
        flex-direction: column;
    }

    .stores-css .box-modal {
        background-color: white !important;
        padding: 10px 15px;
    }

    .stores-css .MainMapCss_Sub {
        display: flex;
        position: absolute;
        /*z-index: 30000;*/
        /*width: 70%;*/
        left: 0;
    }

    .stores-css .map {
        width: 100%;
        height: 100%;
    }

    .stores-css .MainMapCss {
        left: 0;
        height: auto !important;
        /*z-index: 30000;*/
    }
</style>
